// load scss files
import "@/assets/scss/main.scss";

import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";
import ZoomerVue from "vue-zoomer";

// app modules
import Auth from "@/modules/auth";
import Dashboard from "@/modules/dashboard";
import Common from "@/modules/common";
import FozChapeco from "@/modules/foz_chapeco";
import CamposNovos from "@/modules/campos_novos";
import Julho14 from "@/modules/julho_14";
import Settings from "@/modules/settings";
import Profile from "@/modules/profile";
import SwxVisualizer from "@/modules/SwxVisualizer";

// root component
import App from "@/App.vue";

// router and store
import router from "@/router";
import store from "@/store";

Vue.config.productionTip = false;

// bootstrap vue
Vue.use(BootstrapVue);

// vue zoomer
Vue.use(ZoomerVue);

// auth module
Vue.use(Auth, {
    router,
    store
});

// dashboard module
Vue.use(Dashboard, {
    router,
    store
});

// common module
Vue.use(Common, {
    store
});

// settings module
Vue.use(Settings, {
    router,
    store
});

// profile module
Vue.use(Profile, {
    router
});

// foz_chapeco module
Vue.use(FozChapeco, {
    router,
    store
});

// campos_novos module
Vue.use(CamposNovos, {
    router,
    store
});

// julho_14 module
Vue.use(Julho14, {
    router,
    store
});

// vtk visualizer module
Vue.use(SwxVisualizer, {
    store
});

// Vue instance
new Vue({
    router,
    // @ts-ignore
    store,
    render: h => h(App)
}).$mount("#app");
